import { render } from "./App.vue?vue&type=template&id=5c96247c"
const script = {}

import "./App.vue?vue&type=style&index=0&id=5c96247c&lang=scss"

import exportComponent from "/Users/thibertletullier/Workspace/Declic/comex/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__